import React, { useEffect, useState } from "react";
import { BsFacebook } from "react-icons/bs";
import { AiFillTwitterCircle } from "react-icons/ai";
import {
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaPinterestSquare,
  FaSnapchat,
  FaBasketballBall,
  FaGooglePlusG,
} from "react-icons/fa";
import { IoArrowForwardOutline } from "react-icons/io5";
import axios from "axios";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";


const Footer0 = () => {
  const [footerColor, setFooterColor] = useState("#000");
  const [footerTextColor, setFooterTextColor] = useState("#fff");
  const [font, setFont] = useState("");
  const [themeColor, setThemeColor] = useState("#708090");
  const [themeIconColor, setThemeIconColor] = useState("#708090");
  const [socialLinks, setSocialLinks] = useState({});
  const [contactDetails, setContactDetails] = useState(null);
  const [error, setError] = useState(null);
  const accessToken = sessionStorage.getItem("accessToken");
  const navigate = useNavigate();
  const [slogan, setSlogan] = useState("slogan");

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setFooterColor(parsedStyle.footer_color);
      setFooterTextColor(parsedStyle.footer_text_color);
      setFont(parsedStyle.web_font);
      setThemeColor(parsedStyle.web_theme_colour);
      setThemeIconColor(parsedStyle.web_theme_icon_color);

      setSocialLinks({
        facebook: parsedStyle.facebook_link,
        twitter: parsedStyle.twitter_link,
        instagram: parsedStyle.instagram_link,
        pinterest: parsedStyle.pinterest_link,
        linkedin: parsedStyle.linkedin_link,
        youtube: parsedStyle.youtube_link,
        whatsapp: parsedStyle.whatsapp_link,
        snapchat: parsedStyle.snapchat_link,
        dribble: parsedStyle.dribble_link,
        googlePLus: parsedStyle.google_plus_link,
      });
      setSlogan(parsedStyle.slogan);
    }
  }, []);

  const hasAnySocialLink = Object.values(socialLinks || {}).some(
    (link) => link && link.trim() !== ""
  );

  useEffect(() => {
    const fetchContactDetails = async () => {
      const formData = new FormData();
      formData.append("admin_auto_id", sessionStorage.getItem("admin_auto_id"));

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/Show-Contact-Details`,
          formData
        );

        if (response.data.status === 1) {
          setContactDetails(response.data.allcontact_details[0]);
        } else {
          setError("Failed to fetch contact details");
        }
      } catch (error) {
        setError("Error fetching data");
      }
    };

    fetchContactDetails();
  }, []);

  return (
    <div
      className={`p-6 ${font}`}
      style={{ backgroundColor: footerColor, color: footerTextColor }}
    >
      <div className="container grid grid-cols-1 gap-6 mx-auto md:grid-cols-2 lg:grid-cols-5">
        {/* INFORMATION */}
        <div>
          <span
            className="text-xs font-semibold"
            style={{
              color: footerTextColor,
            }}
          >
            INFORMATION
          </span>
          <div className="mt-3 space-y-2">
            <Link
              className="block text-sm hover:underline text-decoration-none text-inherit "
              to="/aboutus"
            >
              About Us
            </Link>
            <Link
              className="block text-sm hover:underline text-decoration-none text-inherit"
              to="/privacyandpolicy"
            >
              Privacy Policy
            </Link>
            <Link
              className="block text-sm hover:underline text-decoration-none text-inherit "
              to="/faq"
            >
              FAQ
            </Link>
            {socialLinks.whatsapp && (
              <a
                href={socialLinks.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="w-12 mt-5 cursor-pointer"
                  src="https://img.icons8.com/?size=100&id=16713&format=png&color=000000"
                  alt="Description"
                />
              </a>
            )}
          </div>
        </div>

        {/* HELPFUL LINKS */}
        <div>
          <span
            className="text-xs font-semibold"
            style={{
              color: footerTextColor,
            }}
          >
            HELPFUL LINKS
          </span>
          <div className="mt-3 space-y-2">
            {accessToken && (
              <Link
                to={{
                  pathname: "/dashboard",
                }}
                state={{ page: "myorders" }}
                className="block text-sm hover:underline text-decoration-none text-inherit"
              >
                Track Your Order
              </Link>
            )}
            <Link
              className="block text-sm hover:underline text-decoration-none text-inherit "
              to="/contact"
            >
              Contact Us
            </Link>
            <Link
              className="block text-sm hover:underline text-decoration-none text-inherit "
              to="/termsandcondition"
            >
              Terms of Service
            </Link>
          </div>
        </div>

        {/* NEWSLETTER */}
        <div>
          <span
            className="text-xs font-semibold"
            style={{
              color: footerTextColor,
            }}
          >
            NEWSLETTER
          </span>
          <p className="mt-3 text-sm">
            {slogan}
          </p>
          <div className="relative mt-3">
            <input
              type="email"
              className="w-full p-2 pr-10 bg-gray-200 rounded-full "
              style={{ color: footerTextColor }}
              placeholder="Your e-mail"
            />
            <button
              className="absolute transform -translate-y-1/2 right-3 top-1/2 "
              style={{ color: footerTextColor }}
            >
              <IoArrowForwardOutline size={20} />
            </button>
          </div>
        </div>

        {/* CONTACT US */}
        <div>
          <span
            className="text-xs font-semibold"
            style={{
              color: footerTextColor,
            }}
          >
            CONTACT US
          </span>
          {contactDetails ? (
            <p className="mt-3 text-sm">
              Dedicated Help Center <br />
              Call Us:{" "}
              <span className="font-semibold">
                +91-{contactDetails.contact}
              </span>{" "}
              {/* <br />({contactDetails.office_hrs}) */}
              <br />
              Email Us at: <span>{contactDetails.email}</span>
            </p>
          ) : (
            <p className="mt-3 text-sm">Loading contact details...</p>
          )}
        </div>

        {/* FOLLOW US */}
        {hasAnySocialLink && (
          <div>
            <span
              className="text-xs font-semibold"
              style={{
                color: footerTextColor,
              }}
            >
              FOLLOW US
            </span>
            <div className="flex mt-3 ">
              {socialLinks.facebook && (
                <a
                  href={socialLinks.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 border-1"
                  style={{ borderColor: themeColor }}
                >
                  {" "}
                  <BsFacebook
                    className="text-2xl transition-opacity duration-300 cursor-pointer"
                    style={{ color: themeIconColor, opacity: 1 }}
                    onMouseEnter={(e) => (e.target.style.opacity = 0.7)}
                    onMouseLeave={(e) => (e.target.style.opacity = 1)}
                  />
                </a>
              )}
              {socialLinks.twitter && (
                <a
                  href={socialLinks.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 border-1"
                  style={{ borderColor: themeColor }}
                >
                  {" "}
                  <AiFillTwitterCircle
                    className="text-2xl transition-opacity duration-300 cursor-pointer"
                    style={{ color: themeIconColor, opacity: 1 }}
                    onMouseEnter={(e) => (e.target.style.opacity = 0.7)}
                    onMouseLeave={(e) => (e.target.style.opacity = 1)}
                  />
                </a>
              )}
              {socialLinks.instagram && (
                <a
                  href={socialLinks.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 border-1"
                  style={{ borderColor: themeColor }}
                >
                  {" "}
                  <FaInstagram
                    className="text-2xl transition-opacity duration-300 cursor-pointer"
                    style={{ color: themeIconColor, opacity: 1 }}
                    onMouseEnter={(e) => (e.target.style.opacity = 0.7)}
                    onMouseLeave={(e) => (e.target.style.opacity = 1)}
                  />
                </a>
              )}
              {socialLinks.pinterest && (
                <a
                  href={socialLinks.pinterest}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 border-1"
                  style={{ borderColor: themeColor }}
                >
                  {" "}
                  <FaPinterestSquare
                    className="text-2xl transition-opacity duration-300 cursor-pointer"
                    style={{ color: themeIconColor, opacity: 1 }}
                    onMouseEnter={(e) => (e.target.style.opacity = 0.7)}
                    onMouseLeave={(e) => (e.target.style.opacity = 1)}
                  />
                </a>
              )}
              {socialLinks.youtube && (
                <a
                  href={socialLinks.youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 border-1"
                  style={{ borderColor: themeColor }}
                >
                  {" "}
                  <FaYoutube
                    className="text-2xl transition-opacity duration-300 cursor-pointer"
                    style={{ color: themeIconColor, opacity: 1 }}
                    onMouseEnter={(e) => (e.target.style.opacity = 0.7)}
                    onMouseLeave={(e) => (e.target.style.opacity = 1)}
                  />{" "}
                </a>
              )}
            </div>
            <div className="flex">
              {socialLinks.linkedin && (
                <a
                  href={socialLinks.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 border-1"
                  style={{ borderColor: themeColor }}
                >
                  {" "}
                  <FaLinkedinIn
                    className="text-2xl transition-opacity duration-300 cursor-pointer"
                    style={{ color: themeIconColor, opacity: 1 }}
                    onMouseEnter={(e) => (e.target.style.opacity = 0.7)}
                    onMouseLeave={(e) => (e.target.style.opacity = 1)}
                  />
                </a>
              )}
              {socialLinks.youtube && (
                <a
                  href={socialLinks.youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 border-1"
                  style={{ borderColor: themeColor }}
                >
                  {" "}
                  <FaYoutube
                    className="text-2xl transition-opacity duration-300 cursor-pointer"
                    style={{ color: themeIconColor, opacity: 1 }}
                    onMouseEnter={(e) => (e.target.style.opacity = 0.7)}
                    onMouseLeave={(e) => (e.target.style.opacity = 1)}
                  />{" "}
                </a>
              )}

              {socialLinks.snapchat && (
                <a
                  href={socialLinks.snapchat}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 border-1"
                  style={{ borderColor: themeColor }}
                >
                  {" "}
                  <FaSnapchat
                    className="text-2xl transition-opacity duration-300 cursor-pointer"
                    style={{ color: themeIconColor, opacity: 1 }}
                    onMouseEnter={(e) => (e.target.style.opacity = 0.7)}
                    onMouseLeave={(e) => (e.target.style.opacity = 1)}
                  />{" "}
                </a>
              )}

              {socialLinks.dribble && (
                <a
                  href={socialLinks.dribble}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 border-1"
                  style={{ borderColor: themeColor }}
                >
                  {" "}
                  <FaBasketballBall
                    className="text-2xl transition-opacity duration-300 cursor-pointer"
                    style={{ color: themeIconColor, opacity: 1 }}
                    onMouseEnter={(e) => (e.target.style.opacity = 0.7)}
                    onMouseLeave={(e) => (e.target.style.opacity = 1)}
                  />{" "}
                </a>
              )}
              {socialLinks.googlePLus && (
                <a
                  href={socialLinks.googlePLus}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 border-1"
                  style={{ borderColor: themeColor }}
                >
                  {" "}
                  <FaGooglePlusG
                    className="text-2xl transition-opacity duration-300 cursor-pointer"
                    style={{ color: themeIconColor, opacity: 1 }}
                    onMouseEnter={(e) => (e.target.style.opacity = 0.7)}
                    onMouseLeave={(e) => (e.target.style.opacity = 1)}
                  />{" "}
                </a>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Footer0;
